<template>
  <div class="coderpix_tm_section" id="news">
    <div class="section_inner">
      <div class="coderpix_tm_news swiper-section">
        <div class="coderpix_tm_main_title">
          <h3>Güncel <span class="coloring">Haberler</span></h3>
        </div>
        <div class="news_list">
          <swiper
            :loop="false"
            :slidesPerView="1"
            :spaceBetween="0"
            :loopAdditionalSlides="1"
            :autoplay="{
              delay: 6000,
            }"
            :navigation="{
              nextEl: '.my_next',
              prevEl: '.my_prev',
            }"
            :pagination="pagination"
            :breakpoints="{
              700: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              1200: {
                slidesPerView: 3,
                spaceBetween: 30,
              },
            }"
            @slideChange="onSlideChange"
            :modules="modules"
            class="swiper-container"
          >
            <swiper-slide
              class="swiper-slide"
              v-for="(data, i) in newsData"
              :key="i"
            >
              <div class="list_inner">
                <div class="image">
                  <img src="img/thumbs/4-3.jpg" alt="" />
                  <div class="main" :data-img-url="data.img"></div>
                  <a class="coderpix_tm_full_link news_popup" href="#"></a>
                </div>
                <div class="details">
                  <h3>
                    <a href="#">{{ data.title }}</a>
                  </h3>
                  <span
                    ><a href="#">{{ data.tag }}</a></span
                  >
                </div>

                <!-- News Popup Informations -->
                <div class="coderpix_tm_hidden_content">
                  <div class="news_popup_details">
                    <div class="top_image">
                      <img src="img/thumbs/4-2.jpg" alt="" />
                      <div class="main" :data-img-url="data.img"></div>
                    </div>
                    <div class="news_main_title">
                      <h3>{{ data.title }}</h3>
                      <span
                        ><a href="#">{{ data.tag }}</a></span
                      >
                      <div></div>
                    </div>
                    <div class="text">
                      <p v-for="(text, t) in data.des" :key="t">
                        {{ text }}
                      </p>
                    </div>
                  </div>
                </div>
                <!-- /News Popup Informations -->
              </div>
            </swiper-slide>
            <div class="coderpix_tm_swiper_progress fill">
              <div class="my_pagination_in">
                <span class="currentNews">0</span>
                <span class="pagination_progress"
                  ><span class="all allNews"><span></span></span
                ></span>
                <span class="totalNews">04</span>
              </div>
              <div class="my_navigation">
                <ul>
                  <li>
                    <a class="my_prev" href="#"
                      ><i class="icon-left-open-1"></i
                    ></a>
                  </li>
                  <li>
                    <a class="my_next" href="#"
                      ><i class="icon-right-open-1"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import { swiperSliderCustomSlider } from "../utilits";
import sanityClient from "../sanity";

export default {
  name: `NewsComponent`,
  components: {
    Swiper,
    SwiperSlide,
  },
  methods: {
    onSlideChange(swiper) {
      this.activeSlider = swiper.activeIndex + 1;
    },
    async fetchNews() {
      try {
        const query = `*[_type == "news"] | order(publishedAt desc) {
          title,
          tag,
          "img": image.asset->url,
          "des": description
        }`;
        const result = await sanityClient.fetch(query);
        if (result && result.length > 0) {
          this.newsData = result.map(item => ({
            title: item.title,
            tag: item.tag,
            img: item.img || "img/news/1.jpg",
            des: item.des || []
          }));
        }
      } catch (error) {
        console.log("Sanity fetch error, using fallback data:", error);
        // Fallback data already set in data()
      }
    }
  },
  mounted() {
    this.fetchNews();
  },
  setup() {
    return {
      modules: [Navigation, Pagination],
      pagination: {
        el: ".coderpix_tm_swiper_progress",
        type: "custom", // progressbar
        renderCustom: function (swiper, current, total) {
          swiperSliderCustomSlider(
            current,
            total,
            "currentNews",
            "totalNews",
            "allNews"
          );
        },
      },
    };
  },
  data() {
    return {
      newsData: [
        {
          title: "2025'te Web Tasarımda Öne Çıkan Trendler",
          img: "img/news/1.jpg",
          tag: "Web Tasarım",
          des: [
            "2025 yılında web tasarım trendleri kullanıcı deneyimini ön plana çıkarıyor. Minimalist tasarımlar, koyu mod seçenekleri ve mikro animasyonlar web sitelerinin vazgeçilmezleri arasında yerini aldı.",
            "Yapay zeka destekli tasarım araçları, tasarımcıların iş akışını hızlandırırken, kişiselleştirilmiş kullanıcı deneyimleri sunmayı mümkün kılıyor. Responsive tasarım artık bir tercih değil, zorunluluk haline geldi.",
            "Modern web siteleri artık sadece bilgi sunmakla kalmıyor, aynı zamanda marka kimliğini yansıtan interaktif deneyimler sunuyor.",
          ],
        },
        {
          title: "N8N ile İş Süreçlerinizi Otomatikleştirin",
          img: "img/news/2.jpg",
          tag: "Otomasyon",
          des: [
            "N8N, açık kaynak kodlu bir iş akışı otomasyon aracı olarak son yıllarda büyük popülerlik kazandı. Kod yazmadan karmaşık otomasyonlar oluşturmanıza olanak tanıyor.",
            "E-posta bildirimleri, sosyal medya paylaşımları, veritabanı senkronizasyonu ve CRM entegrasyonları gibi tekrarlayan görevleri otomatikleştirerek zamandan tasarruf edebilirsiniz.",
            "Self-hosted çözümü sayesinde verileriniz tamamen sizin kontrolünüzde kalıyor ve GDPR uyumluluğu sağlanıyor.",
          ],
        },
        {
          title: "E-Ticaret Pazaryeri Entegrasyonlarının Önemi",
          img: "img/news/3.jpg",
          tag: "E-Ticaret",
          des: [
            "Türkiye'de e-ticaret pazaryerleri (Trendyol, Hepsiburada, Amazon, N11) üzerinden satış yapmak artık işletmeler için kritik bir kanal haline geldi.",
            "Çoklu pazaryeri entegrasyonu, stok ve fiyat yönetimini merkezileştirerek operasyonel verimliliği artırıyor. Tek bir panelden tüm pazaryerlerini yönetmek mümkün.",
            "Doğru entegrasyon çözümleri ile sipariş yönetimi, kargo takibi ve müşteri iletişimi otomatize edilebilir.",
          ],
        },
        {
          title: "Sosyal Medyada Marka Bilinirliği Oluşturma",
          img: "img/news/4.jpg",
          tag: "Sosyal Medya",
          des: [
            "Sosyal medya platformları, markaların hedef kitleleriyle doğrudan iletişim kurmasının en etkili yolu olmaya devam ediyor.",
            "Instagram, LinkedIn ve TikTok gibi platformlarda tutarlı ve değer katan içerikler paylaşmak, organik büyüme için kritik öneme sahip.",
            "Profesyonel grafik tasarımlar ve video içerikler, sosyal medyada dikkat çekmek ve etkileşim oranlarını artırmak için vazgeçilmez.",
          ],
        },
        {
          title: "Kurumsal Kimlik Tasarımının İşletmelere Etkisi",
          img: "img/news/5.jpg",
          tag: "Grafik Tasarım",
          des: [
            "Kurumsal kimlik, bir markanın görsel dilidir. Logo, renk paleti, tipografi ve tasarım öğeleri tutarlı bir şekilde kullanıldığında marka algısını güçlendirir.",
            "Profesyonel logo tasarımı, kartvizit, antetli kağıt ve dijital varlıklar markanızın güvenilirliğini artırır.",
            "İyi tasarlanmış bir kurumsal kimlik, müşterilerinizin zihninde kalıcı bir iz bırakır ve rekabette öne çıkmanızı sağlar.",
          ],
        },
        {
          title: "SEO: Arama Motorlarında Üst Sıralara Çıkın",
          img: "img/news/6.jpg",
          tag: "SEO",
          des: [
            "Arama motoru optimizasyonu (SEO), web sitenizin Google'da görünürlüğünü artırmanın en etkili yoludur. Organik trafik, ücretli reklamlara göre daha sürdürülebilir sonuçlar sağlar.",
            "Teknik SEO, içerik optimizasyonu ve backlink stratejileri, başarılı bir SEO çalışmasının temel taşlarıdır.",
            "Yerel SEO, özellikle fiziksel mağazası olan işletmeler için kritik öneme sahiptir. Google İşletme Profili optimizasyonu ile yerel aramalarda ön plana çıkabilirsiniz.",
          ],
        },
      ],
    };
  },
};
</script>


